const DEDUP_WINDOW_MS = 10_000;
const recentNotifications = new Map<string, number>();

export function getNotificationKey(type: string, message: string): string {
  return `${type}:${message}`;
}

export function isDuplicateNotification(key: string): boolean {
  const lastShown = recentNotifications.get(key);

  return lastShown !== undefined && Date.now() - lastShown < DEDUP_WINDOW_MS;
}

export function trackNotification(key: string): void {
  recentNotifications.set(key, Date.now());

  for (const [k, timestamp] of recentNotifications) {
    if (Date.now() - timestamp >= DEDUP_WINDOW_MS) {
      recentNotifications.delete(k);
    }
  }
}
